import { useEffect } from "react";

/**
 * Attaches an IntersectionObserver to every element with class `vy-reveal`
 * inside the root. When each element enters the viewport, adds `vy-in`
 * which triggers the CSS transition. Runs once per element.
 *
 * Respects prefers-reduced-motion — flag is handled inside landing.css.
 */
export function useScrollReveal(rootRef) {
    useEffect(() => {
        const root = rootRef?.current ?? document;
        const nodes = root.querySelectorAll(".vy-reveal:not(.vy-in)");
        if (!nodes.length) return undefined;

        if (typeof IntersectionObserver === "undefined") {
            nodes.forEach((n) => n.classList.add("vy-in"));
            return undefined;
        }

        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("vy-in");
                        io.unobserve(e.target);
                    }
                });
            },
            { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
        );

        nodes.forEach((n) => io.observe(n));
        return () => io.disconnect();
    }, [rootRef]);
}
